var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" By using this application you agree to the "),_c('router-link',{attrs:{"to":"/legal"}},[_vm._v("Terms of Use")]),_vm._v(" . ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }